export default "__VITE_ASSET__BCP2efFo__"